import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

// Bg + texto + ring sutil pra dar depth Apple-style (camadas separadas)
const styles: Record<Variant, string> = {
  success:
    'bg-emerald-100 text-emerald-800 ring-emerald-200/60 dark:bg-emerald-950/80 dark:text-emerald-200 dark:ring-emerald-800/40',
  warning:
    'bg-amber-100 text-amber-800 ring-amber-200/60 dark:bg-amber-950/80 dark:text-amber-200 dark:ring-amber-800/40',
  danger:
    'bg-rose-100 text-rose-800 ring-rose-200/60 dark:bg-rose-950/80 dark:text-rose-200 dark:ring-rose-800/40',
  info: 'bg-sky-100 text-sky-800 ring-sky-200/60 dark:bg-sky-950/80 dark:text-sky-200 dark:ring-sky-800/40',
  neutral:
    'bg-slate-100 text-slate-700 ring-slate-200/60 dark:bg-slate-800/80 dark:text-slate-200 dark:ring-slate-700/40',
};

const dotStyles: Record<Variant, string> = {
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  danger: 'bg-rose-500',
  info: 'bg-sky-500',
  neutral: 'bg-slate-400',
};

export function StatusBadge({
  variant,
  children,
  className,
  dot = false,
  pulse = false,
}: {
  variant: Variant;
  children: ReactNode;
  className?: string;
  /** Adiciona um dot colorido antes do texto */
  dot?: boolean;
  /** Faz o dot pulsar (use pra "EM_ANDAMENTO", lavagem rolando, etc) */
  pulse?: boolean;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1',
        styles[variant],
        className,
      )}
    >
      {dot && (
        <span className="relative inline-flex h-1.5 w-1.5">
          {pulse && (
            <span
              className={cn(
                'absolute inset-0 inline-flex animate-ping rounded-full opacity-75',
                dotStyles[variant],
              )}
            />
          )}
          <span
            className={cn('relative inline-flex h-1.5 w-1.5 rounded-full', dotStyles[variant])}
          />
        </span>
      )}
      {children}
    </span>
  );
}
